// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2dvd0","content":"ManualTimeModal_content__1z81J"};